// helpers/axiosInstance.js
import axios from "axios";
import { toast } from "react-toastify";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("user");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            toast.error("Session expired. Please login again.");
            localStorage.clear();
            window.location.href = "/";
        }
        return Promise.reject(error);
    }
);

export default API;
